import styles from '../style.module.css';
import { object } from 'prop-types';

BgLayer.propTypes = {
  desc: object,
};

/**
 *
 * @param {ComponentProps} props
 * @param {BackgroundDescription} props.desc
 * @return {JSX.Element}
 */
export function BgLayer(props) {
  const { desc: { id, style, children } = {} } = props;

  return (
    <div id={`bg-layer-${id}`} style={style} className={styles.backgroundLayer}>
      {children}
    </div>
  );
}
